// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.nav-container {\n  background: white;\n}\n.nav-container .bottom-line {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background: #ccd5d4;\n  height: 1px;\n  width: 100%;\n}\n.nav-bar-icon {\n  width: 20px;\n  opacity: 0.7;\n  transition: var(--d-ease);\n}\n.nav-bar-icon:hover {\n  opacity: 1;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
